"use strict";
(() => {
	document.addEventListener("DOMContentLoaded", () => {
		quickSelectCollection();
	});

	document.addEventListener("filter:updated", () => {
		quickSelectCollection(); 
	});

	const quickSelectCollection = () => {
		/** ----------------------------------- **/
		/** ------------- GLOBALS --------------**/
		/** ----------------------------------- **/
		// default
		let collectionItemsInCartCount = 0;
		const cartWatchedCollection = document.querySelector("cart-drawer").dataset.watchedCollectionMixMatch;

		// product cheering bar
		const productCheeringBar = document.querySelector(".mix-and-match-bar");
		const productCheeringBarButton = document.querySelector(".mix-and-match-bar__button");
		const cartDrawer = document.querySelector(".cart-drawer");
		const watchedQuickSelectElement = document.querySelector('[data-quick-select="true"]');
		let veganBowlItemsLength;
		if (productCheeringBarButton) {
			productCheeringBarButton.addEventListener("click", () => {
				document.querySelector("#cart-icon-bubble").click();
			});
		}
		// Quick selection collection template

		/** ------------------------------------------------------------------ **/
		/** function for quick select collection update in cart's cheering-bar **/
		/** ------------------------------------------------------------------ **/
		window.updateWatchingCollection = () => {
			const cartCheeringBarBowlsHint = document.querySelector(".Cart__cheering-bar__bowls");
 			const cartCheeringBarBowlsHintPercentage = document.querySelector(".Cart__cheering-bar__bowls span");
 			const drawerInner = document.querySelector(".cart-drawer .drawer__inner");
 			const cartItems = document.querySelectorAll(".cart-drawer .cart-item");

			// reset counter
			collectionItemsInCartCount = 0;

			// add counter value
			cartItems.forEach((cartItem) => {
				if (cartItem.dataset.quickSelectionItem === "true") {
					const selectedQuanitityOfWantedItem = parseInt(cartItem.querySelector(".quantity__input").value);
					collectionItemsInCartCount += selectedQuanitityOfWantedItem;
				}
			});
			if (collectionItemsInCartCount < 7) {
				cartCheeringBarBowlsHint.style.height = "0px";
				// drawerInner.style.paddingTop = "94px";
			} else if (collectionItemsInCartCount === 7) {
				cartCheeringBarBowlsHint.style.height = "42px";
				cartCheeringBarBowlsHint.style.display = "block";
				cartCheeringBarBowlsHintPercentage.textContent = "5%";
				// drawerInner.style.paddingTop = "136px";
			} else if (collectionItemsInCartCount > 7 && collectionItemsInCartCount < 15) {
				cartCheeringBarBowlsHint.style.height = "42px";
				cartCheeringBarBowlsHintPercentage.textContent = "5%";
				// drawerInner.style.paddingTop = "136px";
			} else if (collectionItemsInCartCount >= 15) {
				cartCheeringBarBowlsHint.style.height = "42px";
				cartCheeringBarBowlsHintPercentage.textContent = "15%";
				// drawerInner.style.paddingTop = "136px";
			} else {
				console.error("fatal error in bs-cart-drawer.js: unexpected integer given");
			}

			if (productCheeringBar != undefined) {
				if (collectionItemsInCartCount < 7) {
					productCheeringBar.setAttribute("data-level", 1);
				} else if (collectionItemsInCartCount < 15) {
					productCheeringBar.setAttribute("data-level", 2);
				} else if (collectionItemsInCartCount >= 15) {
					productCheeringBar.setAttribute("data-level", 3);
				}
			}

			if (productCheeringBar != undefined) {
				let greenColor = "";
				if(collectionItemsInCartCount < Number(document.querySelector(".mix-and-match-bar .product-cheering-bar__hinWrapper").dataset.thresholdMinimumAmount)) {
					greenColor = "#5e5e5e"
				} else {
					greenColor = "#125c46";
				}
				productCheeringBar.querySelectorAll(".product-cheering-bar__block").forEach((block, index) => {
					if (index < collectionItemsInCartCount) {
						block.style.setProperty('--block-background', greenColor);
						block.style.setProperty("--block-circle-background", "#125c46");
						block.style.setProperty("--block-circle-border", "#fff");
					} else {
						block.style.setProperty('--block-background', '#e5e5e5');
						block.style.setProperty("--block-text", "#5e5e5e");
						block.style.setProperty("--block-circle-background", "#fff");
						block.style.setProperty("--block-circle-border", "#e5e5e5");

					}
				});
			}
		};

		/** ----------------------------- **/
		/** Product cheering bar handling **/
		/** ----------------------------- **/
		const fakeUpdateProductCheeringBar = (command) => {
			if (productCheeringBar != undefined) {
				// use old value and add 1 to fake update product cheeringbar
				const widthPerItem = 100 / 15;

				switch (command) {
					case "plus":
						collectionItemsInCartCount += 1;
						break;
					case "minus":
						collectionItemsInCartCount -= 1;
						break;
					default:
						console.error("fatal error in mix-and-match-bar.js: unexpected command given");
				}
				
				if (collectionItemsInCartCount < 7) {
					productCheeringBar.setAttribute("data-level", 1);
				} else if (collectionItemsInCartCount < 15) {
					productCheeringBar.setAttribute("data-level", 2);
				} else if (collectionItemsInCartCount >= 15) {
					productCheeringBar.setAttribute("data-level", 3);
				}

				if (productCheeringBar != undefined) {
					let greenColor = "";
					if(collectionItemsInCartCount < Number(document.querySelector(".mix-and-match-bar .product-cheering-bar__hinWrapper").dataset.thresholdMinimumAmount)) {
						greenColor = "#5e5e5e"
					} else {
						greenColor = "#125c46";
					}
					productCheeringBar.querySelectorAll(".product-cheering-bar__block").forEach((block, index) => {
						if (index < collectionItemsInCartCount) {
							block.style.setProperty('--block-background', greenColor);
							block.style.setProperty('--block-circle-background', '#125C46');

						} else {
							block.style.setProperty('--block-background', '#e5e5e5');
							block.style.setProperty("--block-text", "#5e5e5e");
							block.style.setProperty("--block-circle-background", "#fff");
						}
					});
				}
			}
		};

		(() => {
			if (productCheeringBar != undefined) {
				const silentDcart = () => {
					// check if dcart error is shown and shut its mouth if its wrong
					const dcartCode = document.querySelector("#code");

					if (dcartCode != undefined) {
						if (dcartCode.value == "") {
							cartDrawer.classList.add("discountWrong");
							cartDrawer.classList.remove("Drawer__Footer__CouponActive");
						}
					} else {
						cartDrawer.classList.remove("discountWrong");
					}
				};

				document.addEventListener("DOMContentLoaded", () => {
					silentDcart();

					// when cart gets updated
					document.addEventListener("rerenderCart", () => {
						// iterate over cart items and look if they are contained in specified collection(data attribute), then update cheeringbar on collectionpage
						setTimeout(() => {
							silentDcart();
						}, 1000);
					});
				});

				// intersection observer for bar visibility
				const cheeringBarIntersectionObserver = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							productCheeringBar.classList.toggle("visible", entry.isIntersecting);
						});
					},
					{
						rootMargin: "-40%"
					}
				);

				cheeringBarIntersectionObserver.observe(watchedQuickSelectElement);
			}
		})();

		/** ----------------------------------- **/
		/** Quick selection collection template **/
		/** ----------------------------------- **/
		(() => {
			const cardProductsFromWatchedCollection = document.querySelectorAll('.product-grid .card-wrapper[data-collection="' + cartWatchedCollection + '"]');

			const productCheeringBarCalculator = (cart) => {
				const veganItems = cart.items.filter((item) => Array.isArray(window.mixAndMatchProducts) && window.mixAndMatchProducts.includes(item.variant_id));
				const infoStates = document.querySelector(".mix-and-match-bar__info-state");

				const label = document.querySelector(".mix-and-match-bar .product-cheering-bar__hinWrapper");
				const compareAtPrice = document.querySelector(".mix-and-match-bar .product-cheering-bar__info-compare-at-price s");
				const discountedPrice = document.querySelector(".mix-and-match-bar .product-cheering-bar__info-discounted-price");

				const choosedMealsCounter = document.querySelector(".mix-and-match-bar .counter");


				let veganItemsTotalPriceFormatted;
				let veganItemsTotalDiscountedPriceFormatted;

				let veganItemsTotalQuantity = 0;
				let veganItemsPrice = 0;
				let veganItemsDiscountedPrice = 0;

				veganItems.forEach((veganItem) => {
					veganItemsPrice += veganItem.original_line_price;
					veganItemsDiscountedPrice += veganItem.final_line_price;
					veganItemsTotalQuantity += veganItem.quantity;
				});

				// formatted prices
				veganItemsTotalPriceFormatted = Shopify.scFormatMoney(veganItemsPrice);
				veganItemsTotalDiscountedPriceFormatted = Shopify.scFormatMoney(veganItemsDiscountedPrice);


				if ( veganItemsTotalDiscountedPriceFormatted !== veganItemsTotalPriceFormatted) {
					infoStates.classList.add("active");
				} else {
					infoStates.classList.remove("active");
				}

				if(veganItemsDiscountedPrice > 0) {
					discountedPrice.textContent = veganItemsTotalDiscountedPriceFormatted;
				} else {
					discountedPrice.textContent = Shopify.scFormatMoney(document.querySelector('[data-price]').dataset.price);
				}
				compareAtPrice.textContent = veganItemsTotalPriceFormatted;

				//title counter
				if (veganItemsTotalQuantity === 1 && choosedMealsCounter) {
					choosedMealsCounter.innerHTML = veganItemsTotalQuantity + " Bowl ";
				} else if(choosedMealsCounter){
					choosedMealsCounter.innerHTML = veganItemsTotalQuantity + " Bowls ";
				}

				// label
				const thresholdMinimumAmount = Number(label.dataset.thresholdMinimumAmount);
				const thresholdFirstLevelDiscount = Number(label.dataset.thresholdFirstLevelDiscount);
				const thresholdSecondLevelDiscount = Number(label.dataset.thresholdSecondLevelDiscount);
				
				// Helper function to pluralize bowls text
				const getBowlsText = (count) => `${count} ${count === 1 ? 'Bowl' : 'Bowls'}`;
				
				// Helper function to replace placeholder text
				const replaceWithBowls = (text, count) => text.replace("x bowls", getBowlsText(count));

				// Determine label based on thresholds
				if (veganItemsTotalQuantity < thresholdMinimumAmount) {
					const amountNeeded = thresholdMinimumAmount - veganItemsTotalQuantity;
					label.innerHTML = replaceWithBowls(label.dataset.minimumAmountText, amountNeeded);
				} else if (veganItemsTotalQuantity < thresholdFirstLevelDiscount) {
					const amountNeeded = thresholdFirstLevelDiscount - veganItemsTotalQuantity;
					label.innerHTML = replaceWithBowls(label.dataset.firstLevelDiscount, amountNeeded);
				} else if (veganItemsTotalQuantity === thresholdFirstLevelDiscount) {
					label.innerHTML = label.dataset.secondLevelDiscount;
				} else if (veganItemsTotalQuantity < thresholdSecondLevelDiscount) {
					const amountNeeded = thresholdSecondLevelDiscount - veganItemsTotalQuantity;
					label.innerHTML = replaceWithBowls(label.dataset.thirdLevelDiscount, amountNeeded);
				} else {
					label.innerHTML = label.dataset.fourthLevelDiscount;
				}

				// button text

				const productCheeringBarButton = document.querySelector(".mix-and-match-bar__button-text");
				const productCheeringBarButtonContainer = document.querySelector(".mix-and-match-bar__button");
				const buttonTextMinimumNotReached = productCheeringBarButton.dataset.buttonTextMinimumNotReached;
				const buttonTextThresholdReached = productCheeringBarButton.dataset.buttonTextThresholdReached;
				const amountOfBowls = thresholdMinimumAmount - veganItemsTotalQuantity
				if(amountOfBowls === 1) {
					productCheeringBarButton.innerHTML = buttonTextMinimumNotReached.replace("x bowls", amountOfBowls + " Bowl");
					productCheeringBarButtonContainer.style.setProperty("--button-text-color", "#5E5E5E");
					productCheeringBarButtonContainer.style.setProperty("--button-background-color", "#EEE");
				}
				else if (veganItemsTotalQuantity < thresholdMinimumAmount) {
					productCheeringBarButton.innerHTML = buttonTextMinimumNotReached.replace("x bowls", amountOfBowls + " Bowls");
					productCheeringBarButtonContainer.style.setProperty("--button-text-color", "#5E5E5E");
					productCheeringBarButtonContainer.style.setProperty("--button-background-color", "#EEE");
				} else {
					productCheeringBarButton.innerHTML = buttonTextThresholdReached;
					productCheeringBarButtonContainer.style.setProperty("--button-text-color", "#fff");
					productCheeringBarButtonContainer.style.setProperty("--button-background-color", "#125c46");
				}
			};

			// function to update quick select cards with cart item quantities
			const mapCartQuantitiesWithQuickSelects = () => {
				// Wait for DOM to be fully updated before proceeding
				requestAnimationFrame(() => {
					const cartItemsFromWatchedCollection = document.querySelectorAll('.cart-items .cart-item[data-quick-selection-item="true"]');

					cartItemsFromWatchedCollection.forEach((cartItem) => {
						cardProductsFromWatchedCollection.forEach((card) => {
							if (cartItem.dataset.variantId === card.dataset.variantId) {
								const cartItemQuantityInput = cartItem.querySelector(".quantity__input");
								const cardQuickSelect = card.querySelectorAll(".card__quick-select");
								const cardQuickSelectInput = card.querySelectorAll(".card__quick-select input");

								if (cartItemQuantityInput && cardQuickSelect && cardQuickSelectInput) {
									cardQuickSelect.forEach((selector) => {
										selector.classList.add("active");
									});
									cardQuickSelectInput.forEach((input) => {
										input.value = cartItemQuantityInput.value;
									});
								}
							}
						});
					});

					// Add delay to ensure cart update has been processed by Shopify
					setTimeout(() => {
						fetch("/cart.json")
							.then((response) => response.json())
							.then((cart) => {
								// const veganItems = cart.items.filter((item) => Array.isArray(window.mixAndMatchProducts) && window.mixAndMatchProducts.includes(item.variant_id));
								// veganBowlItemsLength = veganItems.length;
								if (productCheeringBar !== null) {
									productCheeringBarCalculator(cart);
								}
							})
							.catch((error) => {
								console.error('Error fetching cart:', error);
							});
					}, 300); // Wait 300ms for Shopify to process the cart update
				});
			};

			// Enhanced initial call with better timing
			const initializeMapping = () => {
				// Use multiple strategies to ensure DOM is ready
				if (document.readyState === 'loading') {
					document.addEventListener('DOMContentLoaded', mapCartQuantitiesWithQuickSelects);
				} else {
					// DOM is already loaded, but wait a frame to ensure all updates are complete
					requestAnimationFrame(mapCartQuantitiesWithQuickSelects);
				}
			};

			initializeMapping();

			// Enhanced event listener with debouncing
			let rerenderTimeout;
			document.addEventListener("rerenderCart", () => {
				// Clear any pending rerender calls to avoid rapid successive calls
				clearTimeout(rerenderTimeout);
				rerenderTimeout = setTimeout(() => {
					mapCartQuantitiesWithQuickSelects();
				}, 150); // Slightly longer delay to ensure DOM updates are complete
			});

			// quick select on each card
			cardProductsFromWatchedCollection.forEach((card) => {
				const quantitySelector = card.querySelectorAll(".card__quick-select");
				const firstPlusButton = card.querySelectorAll(".card__quick-select--add");
				const input = card.querySelectorAll("input");
				const plusButton = card.querySelectorAll(".card__quick-select__plus");
				const minusButton = card.querySelectorAll(".card__quick-select__minus");

				firstPlusButton.forEach((button) => {
					button.addEventListener("click", () => {
							quantitySelector.forEach((selector) => {
								selector.classList.add("active");
							});
							input.forEach((input) => {
								input.value = 1;
								input.dispatchEvent(new Event("change"));
							});
							document.dispatchEvent(new CustomEvent('minCartQuantityError'));

						fakeUpdateProductCheeringBar("plus");
					});
				});

				plusButton.forEach((button) => {
					button.addEventListener("click", () => {
						quantitySelector.forEach((selector) => {
							selector.classList.add("loading");
						});
						fakeUpdateProductCheeringBar("plus");

					setTimeout(() => {
						input.forEach((input) => {
							input.value = parseInt(input.value) + 1;
							input.dispatchEvent(new Event("change"));
						});
					}, 100);

					setTimeout(() => { 
						quantitySelector.forEach((selector) => {
							selector.classList.remove("loading");
						});
					}, 750);
					});
				});

				minusButton.forEach((button) => {
					button.addEventListener("click", () => {
					quantitySelector.forEach((selector) => {
						selector.classList.add("loading");
					});
					fakeUpdateProductCheeringBar("minus");

					setTimeout(() => {
						input.forEach((input) => {
							input.value = parseInt(input.value) - 1;
							input.dispatchEvent(new Event("change"));
							if (input.value == 0) {
								quantitySelector.forEach((selector) => {
									selector.classList.remove("active");
								});
							}
						});

					}, 100);

					setTimeout(() => {
					quantitySelector.forEach((selector) => {
						selector.classList.remove("loading");
					});
						input.forEach((input) => {
							if (input.value == 0) {
								quantitySelector.forEach((selector) => {
									selector.classList.remove("active");
								});
							}
						})
					}, 750);
				});
				});

				input.forEach((input) => {
					input.addEventListener("change", () => {
					const inputtedCard = input.closest(".card-wrapper__quick-select");
					const depositVariantId = input.dataset.depositId;
					const depositAmount = Number(input.dataset.depositAmount) * Number(input.value);
					let cartUpdates;

					try {
						if (depositAmount) {
							cartUpdates = {
								updates: {
									[depositVariantId]: depositAmount,
									[inputtedCard.dataset.variantId]: input.value,
								},
							};
						} else {
							cartUpdates = {
								updates: {
									[inputtedCard.dataset.variantId]: input.value,
								},
							};
						}

						fetch(window.Shopify.routes.root + "cart/update.js", {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify(cartUpdates),
						})
							.then((response) => response.json())
							.then((response) => {
								fetch(window.location.href)
									.then((response) => response.text())
									.then((responseText) => {
										const html = new DOMParser().parseFromString(responseText, "text/html");
										const oldDrawer = document.querySelector("cart-drawer");
										const newDrawer = html.querySelector("cart-drawer");
										const oldIconCart = document.querySelector("#cart-icon-bubble");
										const newIconCart = html.querySelector("#cart-icon-bubble");
				
				
										if(oldIconCart && newIconCart) oldIconCart.innerHTML = newIconCart.innerHTML;
										if(oldDrawer && newDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
										if (response.item_count == 0) {
											document.querySelector("cart-drawer").classList.add("is-empty");
										} else {
											document.querySelector("cart-drawer").classList.remove("is-empty");
										}

										// else update cart
										setTimeout(() => {
											document.dispatchEvent(new CustomEvent("rerenderCart"));
										}, 100);
									})
									.catch((e) => {
										console.error(e);
									});
							});
					} catch (error) {
						return false;
					}
					});
				});
			});

			// function for: if cart item gets removed completely -> update associated quick select card
			window.removeQuickSelectEntry = (variantId) => {
				const cardProductsFromWatchedCollection = document.querySelectorAll('.product-grid .card-wrapper[data-collection="' + cartWatchedCollection + '"]');

				cardProductsFromWatchedCollection.forEach((cardItem) => {
					if (cardItem.dataset.variantId == variantId) {
						setTimeout(() => {
							// Reset ALL quick-select UIs (desktop + mobile)
							const inputs = cardItem.querySelectorAll(".card__quick-select input");
							const quantitySelectors = cardItem.querySelectorAll(".card__quick-select");

							inputs.forEach((input) => { input.value = 0; });
							quantitySelectors.forEach((selector) => { selector.classList.remove("active"); });
						}, 1000);
					}
				});
			};
		})();
	};
})();

localStorage.setItem('showBackLink', 'true');
